<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">

      <!-- Table Top -->
      <b-row class="d-flex align-items-center">

        <!-- Per Page -->
        <b-col
          cols="12"
          md="8"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-row>
            <!-- Current Financial Date -->
            <b-col
              cols="12"
              md="auto"
            >
              <InputField
                id="current-financial-date"
                v-model="businessFormData.currentFinancialDate"
                :label="$t('Current Financial Date')"
                :placeholder="$t('Current Financial Date')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Current Financial Date -->

            <!-- Current Transaction Date -->
            <b-col
              cols="12"
              md="auto"
            >
              <InputField
                id="current-transaction-date"
                v-model="businessFormData.currentTransactionDate"
                :label="$t('Current Transaction Date')"
                :placeholder="$t('Current Transaction Date')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Current Transaction Date -->

            <!-- Number of days to catch up-->
            <b-col
              cols="12"
              md="auto"
            >
              <InputField
                id="number-of-days-catch-up"
                v-model="businessFormData.numberOfDaysToCatchUp"
                :label="$t('Number of days to catch up')"
                :placeholder="$t('Number of days to catch up')"
                type="text"
                readonly
              />
            </b-col>
          <!-- Number of days to catch up-->
          </b-row>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="4"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="branchRef"
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :items="businessList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>
      <!--
      <template #cell(eodProcessingTimeMS)="data">
        <div v-if="data.value">
          {{ data.value }}
        </div>
      </template> -->

      <template #cell(eodStage)="data">
        <b-badge
          v-if="data.value"
          pill
          :variant="getStatusColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <template #cell(status)="data">
        <b-badge
          pill
          :variant="getStatusColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template
        #cell(actions)="data"
      >
        <div v-if="getUserPermission('OPEN_CLOSE_BUSINESS')">
          <Button
            v-if="data.item.status === 'AwaitingOpen'"
            :loading="isLoading"
            size="sm"
            target="_blank"
            :label="$t('Open Business')"
            @click="handleBusinessItem(data.item)"
          />
          <Button
            v-else-if="data.item.status === 'Open' || data.item.status === 'AutomaticallyOpen'"
            :loading="isLoading"
            size="sm"
            target="_blank"
            :label="$t('Close Business')"
            @click="handleBusinessItem(data.item)"
          />
          <!-- <Button
            v-else
          /> -->
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />
    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchBusiness"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Financial Date From -->
        <b-col md="6">
          <DatePickerField
            id="start-date"
            v-model="filter.startDate"
            rules="required"
            :label="$t('Financial Date From:')"
            :error-name="$t('Financial Date From')"
            :config="datePickerConfig"
            :placeholder="$t('Pick Financial Date')"
          />
        </b-col>
        <!-- Financial Date From -->
        <!-- Financial Date To -->
        <b-col md="6">
          <DatePickerField
            id="start-date"
            v-model="filter.endDate"
            rules="required"
            :label="$t('Financial Date To:')"
            :error-name="$t('Financial Date To')"
            :config="datePickerConfig"
            :placeholder="$t('Pick Financial Date')"
          />
        </b-col>
        <!-- Financial Date To -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BModal, BBadge,
} from 'bootstrap-vue'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../forms/InputField.vue'
import getStatusColor from '../../../helpers/getStatusColor'
import Button from '../../components/button/Button.vue'
import DatePickerField from '../../forms/DatePickerField.vue'
import {
  toDateWithYear, toDateWithCustomTime, dateDifference, dateTimeDifference,
} from '../../../helpers/formatDate'
import { operationPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BModal,
    BBadge,
    BSpinner,
    TablePagination,
    InputField,
    FullScreenSpinner,
    Button,
    DatePickerField,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isReadonly: false,
      isEditable: false,
      isLoading: false,
      isDisabled: false,
      buttonLabel: this.$t('Open'),
      sortBy: 'financialDate',
      sortDesc: false,
      required,
      modalTitle: this.$t('Manage Business'),
      showSpinner: false,
      getStatusColor,
      formatToDateWithYears: toDateWithYear,
      formatToDateWithTime: toDateWithCustomTime,
      getDateDifference: dateDifference,
      getDateTimeDifference: dateTimeDifference,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'financialDate', sortable: true, label: 'Financial Date' },
        { key: 'openTriggerTime', sortable: true, label: 'Date Opened' },
        { key: 'businessOpenedBy', sortable: true, label: 'Opened By' },
        { key: 'closeTriggerTime', sortable: true, label: 'Date Closed' },
        { key: 'businessClosedBy', sortable: true, label: 'Closed By' },
        { key: 'eodStartTime', sortable: true, label: 'EOD Start Time' },
        { key: 'eodEndTime', sortable: true, label: 'EOD End Time' },
        { key: 'eodProcessingTimeMS', sortable: true, label: 'EOD Duration' },
        { key: 'eodStage', sortable: true, label: 'EOD Stage' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
      businessFormData: {
        currentFinancialDate: '',
        currentTransactionDate: '',
        numberOfDaysToCatchUp: '',
        id: '',
      },
      filter: {
        startDate: '',
        endDate: '',
        sortColumn: 'financialDate',
        direction: 'Desc',
        rangeColumn: 'financialDate',
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        ariaDateFormat: 'd/m/Y',
      },
      businessList: [],

    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchBusiness()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchBusiness()
    },
  },
  mounted() {
    this.getFinancialDate()
    this.fetchBusiness()
  },

  methods: {
    ...mapActions({
      getBusiness: 'operations/getBusinessList',
      getCurrentFinancialDate: 'operations/getCurrentFinancialDate',
      setBusinessStatus: 'operations/setBusinessStatus',
    }),

    async getFinancialDate() {
      try {
        const response = await this.getCurrentFinancialDate({ permission: operationPermissions.OPEN_CLOSE_BUSINESS })
        const { status, data } = await response
        if (status === 200) {
          this.businessFormData.currentFinancialDate = this.formatToDateWithYears(data.data.financialDate)
          this.businessFormData.currentTransactionDate = this.formatToDateWithYears(new Date())
          this.businessFormData.numberOfDaysToCatchUp = this.getDateDifference(data.data.financialDate, new Date()) ? `${this.getDateDifference(data.data.financialDate, new Date())} days` : 0
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: responseError.errorMessage })
        })
      }
    },
    async fetchBusiness() {
      try {
        this.isBusy = true
        const response = await this.getBusiness({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
        })
        const { status, data } = response
        if (status === 200) {
          this.businessList = data.data.map(items => ({
            ...items,
            financialDate: items.financialDate !== null ? this.formatToDateWithYears(items.financialDate) : '',
            openTriggerTime: items.openTriggerTime !== null ? this.formatToDateWithTime(items.openTriggerTime) : '',
            closeTriggerTime: items.closeTriggerTime !== null ? this.formatToDateWithTime(items.closeTriggerTime) : '',
            eodStartTime: items.eodStartTime !== null ? this.formatToDateWithTime(items.eodStartTime) : '',
            eodEndTime: items.eodEndTime !== null ? this.formatToDateWithTime(items.eodEndTime) : '',
            eodProcessingTimeMS: items.eodStartTime !== null ? this.getDateTimeDifference(items.eodStartTime, items.eodEndTime) : '',
          }))
          this.totalCount = data.totalItems
          this.getFinancialDate()
        } else {
          this.alertError()
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async handleBusinessItem(items) {
      let statusNumber
      if (items.status === 'AwaitingOpen') {
        statusNumber = 1
        this.buttonLabel = this.$t('Open')
      } else if (items.status === 'Open' || items.status === 'AutomaticallyOpen') {
        statusNumber = 2
        this.buttonLabel = this.$t('Close')
      } else {
        statusNumber = 0
      }
      const updateBusinessStatus = async () => {
        const yourRequest = this.$t('Your request to')
        try {
          this.isLoading = true
          const response = await this.setBusinessStatus({
            eodHistoryRecordID: items.id,
            requestStatus: statusNumber,
          })
          const { status } = await response
          if (status === 200) {
            this.fetchBusiness()
            const successText = this.$t('Business was successful')
            this.alertSuccess({ text: `${yourRequest} ${this.buttonLabel} ${successText}` })
            this.isLoading = false
          }
        } catch (error) {
          error.response.data.errors.forEach(responseError => {
            const errorText = this.$t('Business failed. Reason:')
            this.alertError({ text: `${yourRequest} ${this.buttonLabel} ${errorText} ${responseError.errorMessage}` })
          })
        } finally {
          this.isLoading = false
        }
      }
      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('this Business?')
      this.confirm(updateBusinessStatus, { title: '', text: `${areYouSure} ${this.buttonLabel} ${thisText}` })
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchBusiness()
    },
  },
}
</script>
